import React, { useRef, useEffect } from 'react';
import { gsap } from 'gsap';

const AboutMeCard = () => {
  const cardRef = useRef(null); // Ref for the card animation

  // Animation for AboutMeCard
  useEffect(() => {
    gsap.fromTo(
      cardRef.current,
      { y: '32vh', opacity: 0.0 }, // Start animation from below
      { y: '0vh', opacity: 1, duration: 1.5, ease: 'power4.out', delay: 0.8 } // Animate to its position
    );
  }, []);

  return (
    <div ref={cardRef} style={styles.card}>
      <div style={styles.content}>
        {/* Change the title to a button that routes to the /about page */}
        <a href="/#/about" style={styles.titleLink}>
          <button style={styles.titleButton}>About Me</button>
        </a>
        <p style={styles.description}>
          I'm an Undergraduate student at MSU Denver with a strong curiosity for all things Computer Science. My goals are to go to graduate school and participate in compelling research projects.
        </p>
        {/* Add Resume and CV download buttons */}
        <div style={styles.buttonContainer}>
          <a href="/VincentCordovaResume.pdf" download style={styles.downloadButton}>
            Resume
          </a>
          <a href="/VincentCordovaCV.pdf" download style={styles.downloadButton}>
            CV
          </a>
        </div>
      </div>
    </div>
  );
};

const styles = {
  card: {
    width: '32vw',
    height: '39vh',
    backgroundColor: '#0a0a0a',
    borderRadius: '0 3vw 0 0',
    padding: '2vw',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center', // Adjusted to center content vertically
    alignItems: 'center',
    color: '#fff',
    position: 'absolute',
    bottom: '0',
    left: '62vw',
    overflow: 'hidden',
  },
  content: {
    textAlign: 'center',
  },
  titleLink: {
    textDecoration: 'none',
  },
  titleButton: {
    display: 'inline-block',
    fontSize: '2vh',
    padding: '1vw 2vh',
    backgroundColor: '#0a0a0a',
    color: '#fff',
    borderRadius: '5px',
    textDecoration: 'none',
    cursor: 'pointer',
    border: '1px solid #fff',
  },
  description: {
    fontSize: '2vh',
    marginBottom: '2vh',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    gap: '1vw',
  },
  downloadButton: {
    display: 'inline-block',
    fontSize: '2vh',
    padding: '1vw 2vh',
    backgroundColor: '#0a0a0a',
    color: '#fff',
    borderRadius: '5px',
    textDecoration: 'none',
    cursor: 'pointer',
    border: '1px solid #fff',
  },
};

export default AboutMeCard;
